import { __assign, __makeTemplateObject, __rest, __spreadArray } from "tslib";
import * as React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { forwardRef, useImperativeHandle, useState } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Layout } from '../Layout';
import { ToastNotification, } from './components/ToastNotification';
// Toast Container placement CSS
var placementMap = {
    'top-right': css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    top: 0;\n    right: 0;\n  "], ["\n    top: 0;\n    right: 0;\n  "]))),
    'top-middle': css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n  "], ["\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n  "]))),
    'bottom-right': css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    bottom: 0;\n    right: 0;\n  "], ["\n    bottom: 0;\n    right: 0;\n  "]))),
    'bottom-middle': css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n  "], ["\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n  "]))),
    'bottom-left': css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    bottom: 0;\n    left: 0;\n  "], ["\n    bottom: 0;\n    left: 0;\n  "]))),
};
// Toast Container layout attributes based on placement
var alignmentMap = {
    'top-right': {
        direction: 'column',
        align: 'end',
    },
    'top-middle': {
        direction: 'column',
        align: 'center',
    },
    'bottom-right': {
        direction: 'column-reverse',
        align: 'end',
    },
    'bottom-middle': {
        direction: 'column-reverse',
        align: 'center',
    },
    'bottom-left': {
        direction: 'column-reverse',
        align: 'start',
    },
};
export var Toast = styled(forwardRef(function (props, reference) {
    var id = props.id, className = props.className, _a = props.placement, placement = _a === void 0 ? 'top-right' : _a, layoutProps = __rest(props, ["id", "className", "placement"]);
    // List of active toasts, as ToastNotificationProps objects
    var _b = useState([]), toasts = _b[0], setToasts = _b[1];
    useImperativeHandle(reference, function () {
        return {
            // Function called externally to add a toast to the container
            addToast: function (toastProps) {
                var newProps = toastProps;
                newProps.id = id + "-" + Date.now().toString();
                setToasts(function (current) { return __spreadArray(__spreadArray([], current), [newProps]); });
            },
        };
    });
    return (React.createElement(Layout, __assign({ className: className, gap: "small", padding: "small" }, alignmentMap[placement], layoutProps),
        React.createElement(TransitionGroup, { component: null }, toasts.map(function (toast) { return (React.createElement(CSSTransition, { timeout: 500, classNames: "mds-toast", key: toast.id },
            React.createElement(ToastNotification, __assign({}, toast, { remove: function () {
                    setToasts(toasts.filter(function (t) { return t.id !== toast.id; }));
                } })))); }))));
}))(function (_a) {
    var placement = _a.placement;
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    pointer-events: none;\n    position: fixed;\n    ", ";\n    z-index: 999;\n\n    .mds-toast-exit-active {\n      opacity: 0;\n      transition: opacity 700ms ease-out;\n    }\n  "], ["\n    pointer-events: none;\n    position: fixed;\n    ", ";\n    z-index: 999;\n\n    .mds-toast-exit-active {\n      opacity: 0;\n      transition: opacity 700ms ease-out;\n    }\n  "])), placementMap[placement]);
});
Toast.propTypes = {
    id: PropTypes.string.isRequired,
    placement: PropTypes.oneOf([
        'top-right',
        'top-middle',
        'bottom-right',
        'bottom-middle',
        'bottom-left',
    ]).isRequired,
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=Toast.js.map